import React, { useState, useEffect, useContext } from 'react';
import {
    Upload, Space, message, Modal,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';

import { firebaseStorage } from '../../../shared/firebase.init';
import { useCreateMedia } from '../../../apis/media';
import { AuthContext } from '../../../shared/AuthProvider';

const getBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
});

function FlatImagesContainer({
    entry, onComplete,
}) {
    const [file, setFile] = useState(null);
    const [percent, setPercent] = useState(0);
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState();
    const createMedia = useCreateMedia();
    const { user } = useContext(AuthContext);

    const onUploadCompleted = async (url) => {
        try {
            if (entry && url) {
                const data = {
                    entryId: entry.id,
                    url,
                    name: 'Later',
                    status: 'uploaded',
                    description: '',
                };

                await createMedia.mutateAsync({
                    data,
                    userUid: user?.uid,
                });
                message.success('تم إنشاء الآفات بنجاح');
            }
        } catch (e) {
            message.error('Error!');
        } finally {
            console.log('Done');
            if (onComplete) {
                onComplete(entry, url);
            }
        }
        console.log(loading);
    };

    const handleUpload = () => {
        if (!file) {
            alert('Please upload an image first!');
        }

        const storageRef = ref(firebaseStorage, `/files/${file.name}`);
        console.table(storageRef);

        // progress can be paused and resumed. It also exposes progress updates.
        // Receives the storage reference and the file to upload.
        const uploadTask = uploadBytesResumable(storageRef, file);
        console.log('Reached here');

        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const percentOfUpload = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
                );

                console.log(percentOfUpload);
                // update progress
                setPercent(percentOfUpload);
            },
            (err) => console.log(err),
            () => {
                // download url
                getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                    setLoading(false);
                    setImageUrl(url);
                    console.log(url);
                    console.log(imageUrl);
                    console.log(percent);
                    onUploadCompleted(url);
                });
            },
        );
    };

    useEffect(() => {
        if (file) {
            handleUpload();
        }
    }, [file]);

    const customRequest = ({ onSuccess }) => {
        // You can implement your own logic for image upload here
        // In this example, we simulate a successful upload after a delay
        setTimeout(() => {
            onSuccess();
        }, 1000);
    };

    const handleChange = (info) => {
        setFile(info.file.originFileObj);
    };

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');

    const handleCancel = () => setPreviewOpen(false);
    const handlePreview = async (fileItem) => {
        try {
            let updatedFileItem = { ...fileItem }; // Create a copy of fileItem

            if (!updatedFileItem.url && !updatedFileItem.preview) {
                const preview = await getBase64(updatedFileItem.originFileObj);
                updatedFileItem = { ...updatedFileItem, preview };
            }

            setPreviewImage(updatedFileItem.url || updatedFileItem.preview);
            setPreviewOpen(true);
            setPreviewTitle(updatedFileItem.name || updatedFileItem.url.substring(updatedFileItem.url.lastIndexOf('/') + 1));
        } catch (error) {
            console.error('Error handling preview:', error);
        }
    };
    // const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

    return (
        <Space>
            <Upload
                fileList={file ? [file] : []} // Display the uploaded file
                customRequest={customRequest}
                onChange={handleChange}
                onPreview={handlePreview}
                showUploadList={{ showDownloadIcon: false }}
            >
                {uploadButton}
            </Upload>
            <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                <img
                    alt="example"
                    style={{
                        width: '100%',
                    }}
                    src={previewImage}
                />
            </Modal>
        </Space>
    );
}

export default FlatImagesContainer;
